// START GENAI@CHATGPT4
import * as z from 'zod';
import { isObject, propertyExists } from 'common/type-guards';
//START GENAI@CHATGPT4
export const ConsumerIdentityModel = z.preprocess(
  (val: unknown) => {
    if (!isObject(val)) {
      return val;
    }

    if (propertyExists(val, 'identityProvider')) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (val as any).identityProvider = val.identityProvider;
    }

    if (propertyExists(val, 'identityType')) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (val as any).identityType = val.identityType;
    }

    if (propertyExists(val, 'identityValue')) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (val as any).identityValue = val.identityValue;
    }

    return val;
  },
  z
    .object({
      identityProvider: z.literal('SRC').optional(),
      identityType: z.literal('EMAIL_ADDRESS' as const),
      identityValue: z.string().nullable().optional()
    })
    .refine(
      ({ identityProvider }: { identityProvider?: string }) =>
        identityProvider === undefined || identityProvider === 'SRC',
      {
        message: '"identityProvider" must be "SRC" if present',
        path: ['identityProvider']
      }
    )
    .refine(
      ({ identityType }: { identityType: string }) =>
        typeof identityType === 'string' && identityType.trim() !== '',
      {
        message: '"identityType" must be a non-empty string of "EMAIL_ADDRESS"',
        path: ['identityType']
      }
    )
    .refine(
      ({ identityValue }: { identityValue?: string | null }) =>
        identityValue !== null && identityValue !== undefined,
      {
        message: '"identityValue" must not be null',
        path: ['identityValue']
      }
    )
    .refine(
      ({ identityValue }: { identityValue?: string | null }) =>
        identityValue !== null && identityValue?.trim() !== '',
      {
        message: '"identityValue" must not be empty',
        path: ['identityValue']
      }
    )
    .refine(
      ({ identityValue }: { identityValue?: string | null }) => {
        const emailRegex =
          /^((([a-z]|\d|[!#\$%&\*\+\-\?_])+(\.([a-z]|\d|[!#\$%&\*\+\-\?_])*)*)*)@((([a-z]|\d)|(([a-z]|\d)([a-z]|\d|-|\.|_)*([a-z]|\d)))\.)+(([a-z])|(([a-z])([a-z]|\d|-|\.|_)*([a-z])))$/i;

        return (
          identityValue !== null && identityValue !== undefined && emailRegex.test(identityValue)
        );
      },
      {
        message: '"identityValue" must be a valid email address',
        path: ['identityValue']
      }
    )
);
//END GENAI@CHATGPT4
// END GENAI@CHATGPT4
